export function getFormattedFloatValues(numberValue) {
    return parseFloat((numberValue).toFixed(2));
}

export function getFormattedIntegerValues(numberValue) {
    return parseInt(numberValue, 0);
}

export function calculatePercentage(numberToCalculate, totalNumber) {
    if (totalNumber === 0) {
        return getFormattedFloatValues(0);
    }
    const numberToCalculateFormatted = getFormattedFloatValues(numberToCalculate);
    const formattedValue = getFormattedFloatValues(numberToCalculateFormatted * 100 / totalNumber);

    return formattedValue;
}
